export default Symbol('accordion')
